<template>
  <div id="map" class="fill-height"></div>
</template>

<script>
import MapService from "@/services/map.service.js";
import ownersColor from "@/services/ownersColor.json";

export default {
  name: "Map",

  data() {
    return {
      map: null
    };
  },

  computed: {
    sites() {
      return this.$store.getters["sites/filteredSites"];
    }
  },

  watch: {
    sites() {
      this.addMarkers();
    }
  },

  created() {
    this.$store.dispatch("sites/load");
  },

  mounted() {
    this.map = new MapService("map", 48, 11, 5);
    this.addMarkers();
  },

  methods: {
    addMarkers() {
      this.map.removeMarkers();
      this.sites.forEach(site => {
        if (site.address && site.address.latitude && site.address.longitude) {
          this.map.addMarker(
            site.address.latitude,
            site.address.longitude,
            () => {
              this.$emit("select-site", site);
            },
            site.owner && ownersColor[site.owner.toUpperCase()]
              ? ownersColor[site.owner.toUpperCase()]
              : null
          );
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#map {
  height: 100%;
  width: 100%;
}
</style>

<style lang="scss">
.mapboxgl-marker {
  cursor: pointer;
}
</style>
